import { useContext } from "react";
import { StrapiContext } from "./StrapiContext";

export const useStrapiContext = () => {
  return useContext(StrapiContext);
};
